<script>
  import { onMount } from 'svelte';
  import { push } from 'svelte-spa-router';
  import { isAuthenticated, userInfo } from '@dopry/svelte-auth0';
  import Order from './Order.svelte';

  onMount(async () => {
    if (
      !$isAuthenticated ||
      !$userInfo['http://techsteward.com/roles']?.includes('approver')
    )
      push('/');
  });
</script>

<h5>&nbsp;> Approve</h5>
<br />
<Order mode="approval" />
